import React from "react";
import { Form } from "antd";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { RolesTransfer } from "misc/transfer";

const CustomerAppPermissions = ({ form, name, value, client, disabled, required = false, permissionPrefix }) => {
    const [t] = useTranslation();

    return (
        <Form form={form} initialValues={{ [name]: value }}>
            <Form.Item
                name={name}
                rules={[
                    {
                        required: required,
                        message: t("t_role_modules_is_required")
                    }
                ]}
            >
                <RolesTransfer disabled={disabled} client={client} permissionPrefix={permissionPrefix} />
            </Form.Item>
        </Form>
    );
};

CustomerAppPermissions.propTypes = {
    form: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.array
};

export default CustomerAppPermissions;
